import React from 'react';
import LaunchKeyboardDF from '../components/SimulatorsComponents/DefualtSimulators/LaunchKeyboardDF';

//= ========================================================================
const Sim_T01_launch_keyboard = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <LaunchKeyboardDF
    globJSON={globJSON}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_T01_launch_keyboard;
